(function () {
  function selectButton(wrap, btn) {
    var buttons = wrap.querySelectorAll('[data-ring-size-value]');
    var input = wrap.querySelector('[data-ring-size-custom-property]');
    var currentLabel = wrap.querySelector('[data-ring-size-current]');
    var errorEl = wrap.querySelector('[data-ring-size-error]');

    buttons.forEach(function (b) {
      b.classList.remove('active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-pressed', 'true');

    var val = btn.getAttribute('data-ring-size-value');
    if (input) input.value = val;
    if (currentLabel) currentLabel.textContent = val;
    if (errorEl) errorEl.style.display = 'none';
    wrap.classList.remove('has-error');

    wrap.dispatchEvent(
      new CustomEvent('ring-size:change', {
        bubbles: true,
        detail: { value: val }
      })
    );
  }

  /* Ring Size Finder ("Use this size") lands here: if the picked size
     already exists among the standard buttons, select that button
     directly. Only when the size isn't offered at all does it get added
     as an extra chip. */
  function useFinderSize(wrap, label) {
    var group = wrap.querySelector('.btn-group');
    if (!group) return;

    var existing = null;
    wrap.querySelectorAll('[data-ring-size-value]').forEach(function (b) {
      if (!existing && !b.hasAttribute('data-ring-size-finder-pick') && b.getAttribute('data-ring-size-value') === label) {
        existing = b;
      }
    });

    if (existing) {
      var stalePick = wrap.querySelector('[data-ring-size-finder-pick]');
      if (stalePick) stalePick.remove();

      selectButton(wrap, existing);
      if (existing.scrollIntoView) {
        existing.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      return;
    }

    var pick = wrap.querySelector('[data-ring-size-finder-pick]');
    if (!pick) {
      pick = document.createElement('button');
      pick.type = 'button';
      pick.className = 'variant-btn';
      pick.setAttribute('data-ring-size-finder-pick', 'true');
      pick.setAttribute('aria-pressed', 'false');
      pick.addEventListener('click', function () {
        selectButton(wrap, pick);
      });
    }
    pick.setAttribute('data-ring-size-value', label);
    pick.textContent = label;

    group.appendChild(pick); // (re)appending moves it to the end
    selectButton(wrap, pick);

    if (pick.scrollIntoView) {
      pick.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
    }
  }

  function initSelector(wrap) {
    if (wrap.__ringSizeInit) return;
    wrap.__ringSizeInit = true;

    var buttons = wrap.querySelectorAll('[data-ring-size-value]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectButton(wrap, btn);
      });
    });

    // Default: first size is pre-selected so the field is never empty.
    if (buttons.length && !wrap.querySelector('[data-ring-size-value].active')) {
      selectButton(wrap, buttons[0]);
    }
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-ring-size-selector]').forEach(initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Ring Size Finder integration -- snippets/ring-size-finder.liquid
     dispatches `luzora:ringsize` with detail = { us, uk, eu, d, c } when
     the shopper clicks "Use this size". */
  document.addEventListener('luzora:ringsize', function (e) {
    var s = e.detail;
    if (!s || typeof s.us === 'undefined') return;
    var label = s.us % 1 ? s.us.toFixed(1) : String(s.us);
    document.querySelectorAll('[data-ring-size-selector]').forEach(function (wrap) {
      useFinderSize(wrap, label);
    });
  });

  /* Block add-to-cart / buy-now when a size is required but not chosen yet.
     Runs in the capture phase so it fires before tf-buy-actions' own
     click handler (which listens in the bubble phase). In practice the
     selector always has a default value, this is a safety net. */
  document.addEventListener(
    'click',
    function (e) {
      var actionBtn = e.target.closest('[data-action="add-to-bag"], [data-action="buy-now"]');
      if (!actionBtn) return;

      var root = actionBtn.closest('[data-product-root]') || document;
      var wrap = root.querySelector('[data-ring-size-selector][data-required="true"]');
      if (!wrap) return;

      var input = wrap.querySelector('[data-ring-size-custom-property]');
      if (input && input.value) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var errorEl = wrap.querySelector('[data-ring-size-error]');
      if (errorEl) {
        errorEl.textContent = wrap.getAttribute('data-error-message') || 'Please select a ring size';
        errorEl.style.display = 'block';
      }
      wrap.classList.add('has-error');
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );
})();
